import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import emailjs from '@emailjs/browser';
import './styles/VisitorForm.css';

const VisitorForm = ({ title }) => {
    const { t } = useTranslation();
    const form = useRef();
    const [type, setType] = useState('text');
    const [dialogMessage, setDialogMessage] = useState("");
    const [dialogType, setDialogType] = useState("");
    const [purpose, setPurpose] = useState('Meeting');
    const [submittedEmails, setSubmittedEmails] = useState([]);
    const [selectedTopics, setSelectedTopics] = useState([]);

    const handleTopicChange = (topic) => {
        if (selectedTopics.includes(topic)) {
            setSelectedTopics(selectedTopics.filter(t => t !== topic));
        } else {
            setSelectedTopics([...selectedTopics, topic]);
        }
    };

    const sendEmail = (e) => {
        e.preventDefault();

        const email = form.current['user_email'].value;

        if (submittedEmails.includes(email)) {
            setDialogMessage(t('visitor.emailUsed'));
            setDialogType("error");
            setTimeout(() => setDialogMessage(""), 3000);
            return;
        }

        emailjs
            .sendForm('service_d8nx4rl', 'template_83ojkl8', form.current, {
                publicKey: 'Qj5RXAnOEEROxWVzm',
            })
            .then(
                () => {
                    form.current.reset();
                    setSelectedTopics([]);
                    setDialogMessage(t('visitor.submitSuccess'));
                    setDialogType("success");
                    setSubmittedEmails([...submittedEmails, email]);
                    setTimeout(() => setDialogMessage(""), 3000);
                },
                (error) => {
                    console.log('FAILED...', error.text);
                    setDialogMessage(t('visitor.submitFailed'));
                    setDialogType("error");
                    setTimeout(() => setDialogMessage(""), 3000);
                },
            );
    };

    return (
        <section className="visitor-form-container">
            <div className="visitor-intro">
                <h2>{t('visitor.formWelcomeTitle')}</h2>
                <p>{t('visitor.formWelcomeDesc')}</p>
            </div>

            <div className="visitor-form-card">
                <form ref={form} onSubmit={sendEmail}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label className="form-label">{t('visitor.fullName')}</label>
                            <input
                                className="form-input"
                                type="text"
                                placeholder={t('visitor.placeholderName')}
                                name="user_name"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">{t('visitor.emailAddr')}</label>
                            <input
                                className="form-input"
                                type="email"
                                placeholder={t('visitor.placeholderEmail')}
                                name="user_email"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">{t('visitor.phoneNum')}</label>
                            <input
                                className="form-input"
                                type="tel"
                                placeholder={t('visitor.placeholderPhone')}
                                name="user_tel"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">{t('visitor.dateVisit')}</label>
                            <input
                                className="form-input"
                                type={type}
                                name="user_date"
                                onFocus={() => setType('date')}
                                onBlur={() => setType('text')}
                                placeholder={t('visitor.selectDate')}
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group full-width">
                        <label className="form-label">{t('visitor.purposeVisit')}</label>
                        <div className="purpose-grid">
                            {[
                                { value: 'Meeting', icon: '🤝', label: t('visitor.purposeMeeting') },
                                { value: 'Training', icon: '📚', label: t('visitor.purposeTraining') },
                                { value: 'Consultancy', icon: '💡', label: t('visitor.purposeConsultancy') }
                            ].map((option) => (
                                <label key={option.value} className="purpose-option">
                                    <input
                                        type="radio"
                                        name="purpose"
                                        value={option.value}
                                        checked={purpose === option.value}
                                        onChange={(e) => setPurpose(e.target.value)}
                                    />
                                    <div className="purpose-card">
                                        <span className="purpose-icon">{option.icon}</span>
                                        <span className="purpose-text">{option.label}</span>
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>

                    {(purpose === 'Training' || purpose === 'Consultancy') && (
                        <div className="form-group full-width">
                            <label className="form-label">{t('visitor.selectTopics')}</label>
                            <div className="chip-group">
                                {(purpose === 'Training'
                                    ? ["C", "C++", "Modern C++", "Qt", "QML", "Qt Internal", "OpenGL", "Qt 3D"]
                                    : ["Qt/QML", "Modern C++", "C++"]
                                ).map(topic => (
                                    <label key={topic} className="chip-option">
                                        <input
                                            type="checkbox"
                                            name="user_topics"
                                            value={topic}
                                            checked={selectedTopics.includes(topic)}
                                            onChange={() => handleTopicChange(topic)}
                                        />
                                        <span className="chip-content">{topic}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="form-group full-width" style={{ marginTop: '2rem' }}>
                        <label className="form-label">{t('visitor.yourMessage')}</label>
                        <textarea
                            className="form-textarea"
                            placeholder={t('visitor.placeholderMessage')}
                            name="message"
                            required
                        />
                    </div>

                    <button type="submit" className="submit-btn">
                        {t('visitor.submitBtn')}
                    </button>
                </form>
            </div>

            {dialogMessage && (
                <div className={`form-message ${dialogType}`}>
                    {dialogType === 'success' ? '✅' : '⚠️'} {dialogMessage}
                </div>
            )}
        </section>
    )
}

export default VisitorForm;